import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import AutoTypeRepository from '@/shared/http/repositories/configuration/autotype'
import BrandRepository from '@/shared/http/repositories/configuration/brand'
import BrandModel from '@/shared/models/configuration/brandmodel'
import BrandForms from './brand-form'

export default {
  name: 'Brand',
  mixins: [ActionsForm],
  data () {
    return {
      data: BrandModel,
      form: BrandForms
    }
  },
  components: {
    Cfg
  },
  mounted () {
    this.onLoadAllAutoType()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      BrandRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      BrandRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      BrandRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      BrandRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllAutoType () {
      loading.push()
      AutoTypeRepository.GetAll()
        .then((response) => {
          this.form.autoTypeID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/brand/brand.js